module.exports = __webpack_public_path__ + "media/images/Vectorillus1-73371b29b8d2c19f313f5d37cf4cbaa5.png";